import { render, staticRenderFns } from "./OrderExchange.vue?vue&type=template&id=331af082&scoped=true"
import script from "./OrderExchange.vue?vue&type=script&lang=js"
export * from "./OrderExchange.vue?vue&type=script&lang=js"
import style0 from "./OrderExchange.vue?vue&type=style&index=0&id=331af082&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331af082",
  null
  
)

export default component.exports